import React, { Component } from 'react'
import { PageWrapper, Header, Button, TextField, FormikForm, Toast, FlexWrapper, Footer } from '../components'
import { Formik, Field } from 'formik'
import axios from 'axios'
import { API_URL } from '../constants'
import Cookies from 'js-cookie'
import { get } from 'lodash'
class NominateBrand extends Component {
  state = { openToast: false, isLoading: false }
  handleClose = async (event, reason) => {
    console.log('event')
    if (reason === 'clickaway') {
      return
    }
    await this.setState({ openToast: false })
    this.state.returnToSearch
      ? this.props.history.push({
          pathname: '/products',
          state: {
            searchFocus: true
          }
        })
      : this.props.history.goBack()
  }

  componentDidMount() {
    this.setState({ returnToSearch: get(this.props, 'location.state.returnToSearch', false) })
  }

  render() {
    const { isLoading, openToast, returnToSearch } = this.state
    console.log('returnToSearch', returnToSearch)
    return (
      <React.Fragment>
        <Header
          title={'Nominate Brand/Product'}
          icon="arrowBack"
          onClickBack={() =>
            Cookies.get('prevPath') ? this.props.history.replace(Cookies.get('prevPath')) : this.props.history.goBack()
          }
          color="#fff"
        />
        <PageWrapper viewPadding="22.4% 3.9% 6%">
          <FlexWrapper height={'calc(100% - 8.4%)'} justifyContent="space-between" alignItems="center">
            <Formik
              enableReinitialize
              initialValues={{
                brand: '',
                product: ''
              }}
              onSubmit={async val => {
                this.setState({ isLoading: true })
                await axios.post(`${API_URL}/UserFeedbacks`, {
                  userId: Cookies.get('user_id'),
                  type: 'Nominate Product',
                  extra_one: val.brand,
                  extra_two: val.product
                })
                this.setState({ isLoading: false, openToast: true })
              }}
              render={formikBag => (
                <React.Fragment>
                  <FormikForm height="calc(100% - 8.4%)" justifyContent="space-between">
                    <div>
                      <Field
                        name="brand"
                        render={({ field }) => (
                          <TextField
                            {...field}
                            type="text"
                            label="Brand"
                            margin="30px 14px"
                            width="auto"
                            fontSize="18px"
                            fontColor="#124b5f"
                            required
                          />
                        )}
                      />
                      <Field
                        name="product"
                        render={({ field }) => (
                          <TextField
                            {...field}
                            type="text"
                            label="Product"
                            margin="30px 14px"
                            width="auto"
                            fontSize="18px"
                            fontColor="#124b5f"
                            required
                          />
                        )}
                      />
                    </div>
                    <Button
                      volume="filled"
                      type="submit"
                      label="Submit"
                      namespace="Nominate Product/Brand"
                      disabled={isLoading}
                      isLoading={isLoading}
                    />
                  </FormikForm>
                </React.Fragment>
              )}
            />
          </FlexWrapper>
        </PageWrapper>
        <Toast
          open={openToast}
          message="This brand has been nominated"
          autoHideDuration={300}
          onClose={this.handleClose}
          slideFromTop
        />
        <Footer />
      </React.Fragment>
    )
  }
}

export default NominateBrand



// WEBPACK FOOTER //
// ./src/pages/NominateBrand.js